import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { format } from 'date-fns';
import { Formik, Form } from 'formik';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import FormikDateRangePicker from 'components/Formik/FormikDateRangePicker';
import Title from 'components/Title';
import { useFetchReportsByTotalOnly } from 'hooks/reports/useFetchReportsByTotalOnly';
// import { addMonthsToDate } from 'utils/helpers';

import ReportsByTotalTable from './ReportsByTotalTable';
import { initialReportsByTotalFormData, reportsByTotalValidationSchema } from './schema';

const ReportsByTotal: React.FC<unknown> = () => {
  const { t } = useTranslation(['common', 'reports']);
  const formikRef = useRef<any>();

  const { data, status, mutateAsync } = useFetchReportsByTotalOnly();

  const handleFormSubmit = (values: typeof initialReportsByTotalFormData) => {
    const postData = {
      start_date: values.date_range[0] !== null ? format(values.date_range[0], 'MM-dd-yyyy') : '',
      end_date: values.date_range[1] !== null ? format(values.date_range[1], 'MM-dd-yyyy') : '',
    };

    mutateAsync(postData);
  };

  return (
    <div>
      <Title>{t('reports:reportByTotalsOnly')}</Title>
      <Flex mt="5" justifyContent="center">
        <Formik
          initialValues={initialReportsByTotalFormData}
          validationSchema={reportsByTotalValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {formikBag => {
            formikRef.current = formikBag;
            return (
              <Form autoComplete="off">
                <Grid display="inline-grid" templateColumns={{ base: '1fr', sm: '280px 1fr' }} gap={{ base: 0, sm: 4 }}>
                  <GridItem>
                    <FormikDateRangePicker
                      label={t('common:dateRange')}
                      name="date_range"
                      // datePickerProps={{
                      //   maxDate: addMonthsToDate(new Date(values.date_range[0] ?? ''), 2),
                      // }}
                    />
                  </GridItem>
                  <GridItem mt={{ base: 0, sm: '6' }}>
                    <Button type="submit" colorScheme="secondary" isLoading={status === 'loading'}>
                      {t('reports:generateReport')}
                    </Button>
                  </GridItem>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Flex>
      {data ? <ReportsByTotalTable data={data} dateRange={formikRef?.current?.values?.date_range} /> : null}
    </div>
  );
};

export default ReportsByTotal;
